import React from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton } from '@material-ui/core'
import { useStyles } from './Styles'
import CloseIcon from '@material-ui/icons/Close'

export default function CustomDialog({ isOpen, onClose, maxWidth, fullWidth, title, children }) {
  const classes = useStyles()
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle className={classes.dialogTitle}>
        {title}
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  )
}